import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { ChartsModule } from 'ng2-charts';

import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SharedModule } from 'app/_shared/shared.module';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { CKEditorModule } from 'ng2-ckeditor';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
import { ComparePageAnalyticManagerComponent } from './compare-page-analytic.component';
import { ComparePageAnalyticService } from './compare-page-analytic.service';

const routes: Routes = [
  {
    path: '',
    component: ComparePageAnalyticManagerComponent,
    data: {
      title: 'Báo cáo so sánh hình thức bài đăng trên Fanpage'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    CKEditorModule,
    NgxPaginationModule
  ],
  declarations: [ComparePageAnalyticManagerComponent],
  providers: [ComparePageAnalyticService]
})
export class ComparePageAnalyticModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/compare-page-analytic/compare-page-analytic.module.ts